import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Car, Plane, MapPin } from 'lucide-react';
import { clearRouteSeo } from '../components/SEO';

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const NotFoundPage = ({ language = 'ro' }) => {
  const isRo = language === 'ro';
  const prefix = isRo ? '' : '/en';

  useEffect(() => {
    clearRouteSeo();
    document.title = isRo ? 'Pagina nu a fost găsită (404) | Montréon' : 'Page not found (404) | Montréon';
    setMeta('robots', 'noindex,follow');
    setMeta('prerender-status-code', '404');
    setMeta('description', isRo ? 'Pagina căutată nu există.' : 'The requested page does not exist.');
    return () => document.querySelector('meta[name="prerender-status-code"]')?.remove();
  }, [isRo]);

  const links = [
    { to: `${prefix}/`, icon: Home, label: isRo ? 'Pagina principală' : 'Homepage' },
    { to: `${prefix}/rent-a-car`, icon: Car, label: isRo ? 'Închirieri Auto' : 'Car Rentals' },
    { to: `${prefix}/transfers`, icon: Plane, label: isRo ? 'Transfer Aeroport' : 'Airport Transfers' },
    { to: `${prefix}/tours`, icon: MapPin, label: isRo ? 'Tururi Turistice' : 'Touristic Tours' },
  ];

  return (
    <section className="min-h-[70vh] pt-32 pb-20 px-4 sm:px-6 lg:px-8 bg-white" data-testid="not-found-page">
      <div className="max-w-2xl mx-auto text-center">
        <p className="text-[#10B981] text-sm font-semibold tracking-[0.15em] uppercase mb-3">{isRo ? 'Eroare 404' : 'Error 404'}</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-[#0D1B3E] mb-4" data-testid="not-found-title">
          {isRo ? 'Pagina nu a fost găsită' : 'Page not found'}
        </h1>
        <p className="font-body text-base text-gray-500 leading-relaxed mb-10">
          {isRo
            ? 'Adresa accesată nu există sau a fost mutată. Verifică linkul sau alege una dintre paginile de mai jos.'
            : 'The address you opened does not exist or has been moved. Check the link or choose one of the pages below.'}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {links.map(({ to, icon: Icon, label }) => (
            <Link key={to} to={to} data-testid={`not-found-link-${to.replace(/\//g, '') || 'home'}`}
              className="flex items-center gap-3 rounded-xl border border-gray-200 px-5 py-4 text-left font-body text-[#0D1B3E] hover:border-[#10B981] hover:text-[#10B981] transition-colors">
              <Icon className="w-5 h-5 text-[#10B981]" />
              <span className="font-semibold">{label}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
